import React, { useEffect } from "react";
import { Box, Card } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import CheckoutHeader from "../CheckoutHeader/CheckoutHeader";
import { useCheckoutContext } from "../../context/useCheckoutContext";
import { CheckoutFooter } from "../commons/CheckoutFooter/CheckoutFooter";
import { LoadingInitial } from "../commons/LoadingInitial/LoadingInitial";
import { LoadingOverlay } from "../commons/LoadingOverlay/LoadingOverlay";
import { defaultTo } from "lodash";
import { withLocalize } from "react-localize-redux";
import { renderToStaticMarkup } from "react-dom/server";
import { LanguageEnum } from "../../infrastructure/LanguageEnum";
import { availableLanguages, getAppTranslations, } from "../../service/MultiLanguage";
import Notification from "../commons/Notification/Notification";
var useStyles = makeStyles(function (theme) {
    var _a, _b, _c;
    return ({
        body: (_a = {
                padding: theme.spacing(3),
                paddingBottom: 0
            },
            _a[theme.breakpoints.down("xs")] = {
                height: "auto",
                padding: theme.spacing(2),
            },
            _a),
        card: (_b = {
                background: "#FFFFFF",
                borderRadius: theme.spacing(1),
                boxShadow: "0px 15px 35px rgba(60, 66, 87, 0.12), 0px 5px 15px rgba(0, 0, 0, 0.12)",
                minHeight: "350px",
                position: "relative"
            },
            _b[theme.breakpoints.down("xs")] = {
                height: "auto",
                minHeight: "350px",
            },
            _b),
        payments: (_c = {
                paddingBottom: 0
            },
            _c[theme.breakpoints.down("xs")] = {
                height: "auto",
                minHeight: theme.spacing(46),
            },
            _c),
    });
});
var useLocalize = function (props, languageSelected) {
    useEffect(function () {
        props.initialize({
            languages: availableLanguages,
            options: { renderToStaticMarkup: renderToStaticMarkup },
            translation: getAppTranslations(),
        });
        props.setActiveLanguage(Object.values(LanguageEnum).includes(languageSelected)
            ? languageSelected
            : LanguageEnum.SPANISH);
    }, [languageSelected]);
};
export var CheckoutMain = function (props) {
    var classes = useStyles();
    var _a = useCheckoutContext(), Component = _a.checkoutSection.body.component, checkoutLoading = _a.checkoutLoading, tokenRequestLoading = _a.tokenRequestLoading, language = _a.language, errorNotification = _a.errorNotification, closeErrorNotification = _a.handlers.closeErrorNotification;
    useLocalize(props, language);
    return (React.createElement(Card, { className: classes.card },
        React.createElement(CheckoutHeader, null),
        React.createElement(Notification, { text: defaultTo(errorNotification.text, ""), setCloseErrorNotification: closeErrorNotification, open: errorNotification.open }),
        React.createElement(Box, { className: classes.body }, Component && React.createElement(Component, null)),
        checkoutLoading && React.createElement(LoadingInitial, null),
        tokenRequestLoading && React.createElement(LoadingOverlay, null),
        React.createElement(CheckoutFooter, null)));
};
export default withLocalize(CheckoutMain);
